import { Fragment } from 'react';
import { PageBtn, PageButtons, Pagination } from './styles';

interface ContractsPaginationProps {
  page: number;
  totalPages: number;
  total: number;
  itemCount: number;
  onPageChange: (p: number) => void;
}

export function ContractsPagination({
  page,
  totalPages,
  total,
  itemCount,
  onPageChange,
}: ContractsPaginationProps) {
  const pages: number[] = (() => {
    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, i) => i);
    }
    const set = new Set<number>([0, totalPages - 1, page]);
    for (let d = 1; d <= 2; d++) {
      if (page - d >= 0) set.add(page - d);
      if (page + d < totalPages) set.add(page + d);
    }
    return Array.from(set).sort((a, b) => a - b);
  })();

  return (
    <Pagination>
      <span>
        Стр. {page + 1} из {totalPages} · показано {itemCount} из {total}
      </span>
      <PageButtons>
        <PageBtn
          type="button"
          onClick={() => onPageChange(Math.max(0, page - 1))}
          disabled={page === 0}
        >
          ← Назад
        </PageBtn>
        {pages.map((p, idx) => {
          const prev = idx > 0 ? pages[idx - 1] : -1;
          const showGap = idx > 0 && p - prev > 1;
          return (
            <Fragment key={p}>
              {showGap && (
                <PageBtn key={`gap-${p}`} disabled>
                  …
                </PageBtn>
              )}
              <PageBtn key={p} type="button" $active={p === page} onClick={() => onPageChange(p)}>
                {p + 1}
              </PageBtn>
            </Fragment>
          );
        })}
        <PageBtn
          type="button"
          onClick={() => onPageChange(Math.min(totalPages - 1, page + 1))}
          disabled={page >= totalPages - 1}
        >
          Вперёд →
        </PageBtn>
      </PageButtons>
    </Pagination>
  );
}
